import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

enum LanguageEnum {
  IT = 'it',
  EN = 'en'
}

@Component({
  selector: 'app-privacy-policy-page',
  templateUrl: 'privacy-policy.page.html',
  styleUrls: [
    './styles/privacy-policy.page.scss'
  ]
})
export class PrivacyPolicyPage {

  language = 'it';

  LanguageEnum = LanguageEnum;

  constructor(private modalController: ModalController) {
    this.language = localStorage.getItem('language') || 'it';
  }

  dismiss(): void {
    this.modalController.dismiss();
  }

  goToPrivacyPolicy(language: string) {
    window.open(`https://www.onam.it/privacy-policy/`, '_blank');
  }
}
